export const castList = [
  {
    id: "chen-rui",
    name: "陈锐",
    role: "沈书言",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20a%20composed%20middle%20aged%20Chinese%20man%20in%20a%20dark%20tailored%20coat%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-chen-rui&orientation=squarish",
    bio: "高中同学会的召集人，外人眼中事业稳定、家庭美满，却始终无法放下十年前那个未说出口的承诺。",
    tags: ["同学会发起人", "旧日暗恋", "事业有成"],
  },
  {
    id: "lin-wan",
    name: "林晚",
    role: "苏雯",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20a%20gentle%20Chinese%20woman%20with%20soft%20wavy%20hair%20and%20a%20pale%20knit%20sweater%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-lin-wan&orientation=squarish",
    bio: "沈书言的妻子，温柔而隐忍，一次偶然的同学会邀约让她重新审视这段婚姻里被忽略的部分。",
    tags: ["主人公妻子", "温柔隐忍", "婚姻困局"],
  },
  {
    id: "zhou-yu",
    name: "周屿",
    role: "陆明远",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20a%20confident%20Chinese%20man%20in%20his%20forties%20wearing%20a%20crisp%20shirt%2C%20subtle%20frown%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-zhou-yu&orientation=squarish",
    bio: "当年的班长，如今小有成就的商人，最擅长在饭桌上维持体面，也最害怕有人提起那本同学录。",
    tags: ["老班长", "体面商人", "暗流涌动"],
  },
  {
    id: "he-jia-nan",
    name: "何佳楠",
    role: "方晴",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20an%20outgoing%20Chinese%20woman%20with%20short%20bob%20hair%20and%20a%20bold%20red%20jacket%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-he-jianan&orientation=squarish",
    bio: "心直口快的旧日闺蜜，喜欢把话说在明面上，也是整场同学会上第一个戳破谎言的人。",
    tags: ["毒舌闺蜜", "直来直往", "真相推手"],
  },
  {
    id: "xu-cheng",
    name: "徐承",
    role: "顾南川",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20a%20mysterious%20lean%20Chinese%20man%20in%20a%20dark%20turtleneck%2C%20calm%20gaze%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-xu-cheng&orientation=squarish",
    bio: "十年间音讯全无的神秘同学，在同学会当晚突然现身，随身带着一封没有人愿意拆开的信。",
    tags: ["神秘归来", "关键信件", "未解往事"],
  },
  {
    id: "qi-yan",
    name: "祁妍",
    role: "唐心怡",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20an%20elegant%20Chinese%20woman%20with%20polished%20makeup%20and%20a%20silk%20blouse%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-qi-yan&orientation=squarish",
    bio: "表面光鲜的社交名媛，朋友圈里的人生赢家，只有在深夜独自一人时才卸下所有精心维护的假面。",
    tags: ["光鲜人设", "隐藏秘密", "社交名媛"],
  },
  {
    id: "luo-xi",
    name: "罗希",
    role: "江雪",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20a%20calm%20professional%20Chinese%20woman%20in%20a%20grey%20blazer%20with%20straight%20hair%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-luo-xi&orientation=squarish",
    bio: "冷静克制的事务所律师，习惯用条款和证据说话，却在同学会上第一次为当年的一件旧事松了口。",
    tags: ["职业律师", "冷静理性", "旧事真相"],
  },
  {
    id: "yan-song",
    name: "严嵩",
    role: "沈父",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20character%20portrait%20of%20an%20elderly%20Chinese%20man%20with%20grey%20hair%20and%20a%20woolen%20vest%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20soft%20film%20grain%2C%20studio%20neutral%20dark%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20key%20light%2C%20high%20detail%2C%20moody%20dramatic%20tone&width=400&height=400&seq=cast-yan-song&orientation=squarish",
    bio: "沈书言沉默寡言的父亲，用一辈子守着一个家庭的秘密，直到同学会的照片再次出现在家里。",
    tags: ["父辈秘密", "沉默长者", "家族往事"],
  },
];